import * as React from 'react';
import { useSelector } from 'react-redux';

import { selectSavedSearches } from '../../selectors/savedSearches';
import { EmptyListContainer } from './EmptyListContainer';
import { EDeviceType } from '../../types/device';
import { selectPage } from '../../selectors';
import { MobileSavedSearches } from './MobileSavedSearches';
import { DesktopSavedSearches } from './DesktopSavedSearches';

export const SavedSearches: React.FC = () => {
  const { searches } = useSelector(selectSavedSearches);
  const { deviceType } = useSelector(selectPage);

  if (!searches || !searches.length) {
    return <EmptyListContainer />;
  }

  return deviceType === EDeviceType.Desktop ? (
    <DesktopSavedSearches searches={searches} />
  ) : (
    <MobileSavedSearches searches={searches} />
  );
};
